import { API } from "./api";

/**
 * Resolve local upload paths (/uploads/...) to full backend URLs.
 */
export function resolveMediaUrl(url) {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//")) {
    return url;
  }
  if (url.startsWith("/uploads")) {
    const base = API.replace(/\/api$/, "");
    return `${base}${url}`;
  }
  return url;
}
